import { primaryPhoneNumber, secondaryPhoneNumber } from '../_constants/brand-contact'

export const FreeShippingPlaceHolder = '{FREE_SHIPPING}'
export const PackagingCostPlaceHolder = '{PACKAGING_COST_TEXT}'

export const FAQ_DATA = [
    {
        category: 'ضمانت خانومی',
        id: 'guarantee',
        faqs: [
            {
                question: 'آیا خانومی اصالت کالاها را تضمین می‌کند؟',
                answer: 'خانومی نمایندگی رسمی برندهای آرایشی بهداشتی و مراقبتی را داراست و تمامی محصولات را بدون واسطه، مستقیماً از تولیدکننده اصلی یا وارد کننده رسمی برند دریافت نموده و عرضه می‌نماید. به این ترتیب، اصالت کالا، قیمت نمایندگی و تاریخ انقضای درست محصول با اطمینان توسط خانومی تضمین می‌شود.',
            },
            {
                question: 'آیا خانومی تاریخ انقضای محصولات را تضمین می‌کند؟',
                answer: `
                همراه گرامی، محصولات در خانومی تازه تولید هستند. محصولات ایرانی با تاریخ انقضای بالای ۶ ماه توسط خانومی تضمین می‌شوند. <br />
                در صورتی که تاریخ انقضای کالایی کمتر از زمان مذکور باشد، در صفحه محصول درج می‌شود و به اطلاع شما می‌رسد تا با آگاهی کامل از شرایط خاص کالا، خرید خود را انجام دهید.`,
            },
            {
                question: 'ضمانت تطابق کالا با سایت به چه معنا است؟',
                answer: 'برای هر یک از کالاها در سایت، اطلاعاتی از قبیل نام، عکس و ویژگی‌های محصول درج شده است و ما تضمین می‌کنیم کالایی که به دست شما می‌رسد از همه نظر، دقیقا همان کالایی است که در سایت دیده و انتخاب کرده‌اید؛ یعنی تضمین تطابق کالا با سایت. در غیر اینصورت، کالا از شما پس گرفته می‌شود و تمام هزینه‌ها اعم از هزینه کالا، هزینه ارسال و هزینه باز پس فرستادن آن، به شما بازگردانده می‌شود. لطفاً توجه فرمایید که اطلاعات موجود در صفحه محصول به معنی توصیه یا مشاوره نیست و مسئولیت انتخاب کالا براساس نیازتان، بر عهده شماست.',
            },
            {
                question: 'اگر کالا سالم به دستم نرسید، چه اقدامی انجام دهم؟',
                answer: 'در صورتی که کالا در فرآیند ارسال خراب شده یا مشکلی داشته باشد، تا ۷ روز بعد از تحویل، بازپس گرفته شده و پس از بررسی و احراز مشکل، کالا مرجوع می‌شود. بنابراین لازم است حداکثر تا ۷ روز پس از دریافت بسته، با امور مشتریان خانومی تماس بگیرید و موضوع را اطلاع دهید. برای اطلاع از نحوه بازگشت کالا، گزینه «بازگشت کالا» را مطالعه نمایید.',
            },
            {
                question: 'آیا کالاهای برقی دارای گارانتی می‌باشند؟',
                answer: 'کالاهای مک استایلر و والروس دارای کارت گارانتی شرکتی بوده و کارت گارانتی در جعبه محصول موجود می‌باشد.',
            },
            {
                question: 'آیا طلای موجود در خانومی اصل است و دارای شناسنامه معتبر می‌باشد؟',
                answer: 'کالاها در خانومی با فاکتور رسمی مورد تایید اتحادیه طلا و جواهر عرضه می‌شوند و دارای شناسنامه معتبر هستند.',
            },
            {
                question: 'عیار طلا در خانومی چند است؟',
                answer: 'تمام زیورآلات طلا عرضه‌شده در خانومی ۱۸ عیار هستند.',
            },
            {
                question: 'آیا اجرت ساخت محصولات طلا در سایت مشخص است؟',
                answer: 'اجرت ساخت در صفحه محصول در خانومی مشخص شده است.',
            },
            {
                question: 'آیا در خانومی طلای دسته دوم و یا بدون اجرت  نیز فروخته می‌شود؟',
                answer: 'در حال فقط طلای نو با اجرت مشخص و قانونی عرضه می‌شود.',
            },
        ],
    },
    {
        category: 'ثبت سفارش',
        id: 'order',
        faqs: [
            {
                question: 'چطور در خانومی ثبت نام کنم؟',
                answer: 'از طریق نشان حساب کاربری در بالای صفحه، وارد بخش ورود و ثبت‌نام شوید. شماره تلفن همراه خود را وارد کنید و دکمه «ورود/ثبت‌نام» را کلیک کنید. پس از دریافت کد تایید، آن را در این بخش وارد کنید تا مراحل ورود و ثبت‌نام شما کامل شود.',
            },
            {
                question: 'چطور کالای مناسب را انتخاب کنم؟',
                answer: 'برای انتخاب کالای مورد نظر، شما می‌توانید از طریق جست‌وجو در سایت یا نوار منو، به دسته‌بندی یا برند مورد نظر خود بروید و کالای مورد نیاز خود را انتخاب کنید. توضیحات معرفی محصول، نحوه مصرف و دیدگاه‌های کاربران می‌توانند به شما برای انتخاب بهتر کالا کمک کنند، اما توجه فرمایید این توضیحات به معنی مشاوره خرید نیست. بهتر است کالا را با محصولات مشابه مقایسه کنید تا انتخاب درستی بر اساس نیازتان انجام دهید.',
            },
            {
                question: 'چطور می‌توانم محصول را خریداری کنم؟',
                answer: 'برای خرید کالای مورد نظرتان، در صفحه آن کالا، روی دکمه «افزودن به سبد خرید» کلیک و کالا را به سبد خرید خود اضافه کنید. پس از افزودن تمامی کالاهای مورد نظرتان به سبد خرید، از طریق نشان سبد در بالای صفحه، وارد سبد خرید خود شوید. سپس با کلیک روی گزینه «ثبت سفارش»، به بخش انتخاب آدرس و زمان تحویل هدایت می‌شوید. پس از تکمیل این بخش، روش پرداخت خود را انتخاب کرده و خرید خود را تکمیل کنید. پس از پرداخت، شماره سفارش از طریق پیامک برای شما ارسال خواهد شد.',
            },
            {
                question: 'چطور از کد تخفیف استفاده کنم؟',
                answer: 'روی نشان سبد خرید در بالای سایت کلیک کنید و وارد سبد خرید خود شوید. در انتهای لیست کالاهای موجود در سبد خریدتان، می‌توانید کد تخفیف خود را وارد و روی گزینه «بررسی کد» کلیک کنید. توجه داشته باشید برای بررسی کد باید وارد سایت شوید. در صورتی که شرایط استفاده از کد را داشته باشید و زمان آن منقضی نشده باشد، تخفیف یا هدیه مربوط به آن کد، بر روی فاکتور شما اعمال خواهد شد. در غیر این صورت، پیام خطای متناسب با آن را مشاهده خواهید کرد.',
            },
            {
                question: 'شرایط دریافت هدیه چیست؟',
                answer: 'در صفحه برخی محصولات درج شده است که با خرید آن‌ها هدیه دریافت می‌کنید. در این صورت، با افزودن آن محصول به سبد خریدتان، هدیه هم به صورت اتوماتیک به سبد خرید شما اضافه خواهد شد. شما بابت این هدیه، هیچ هزینه‌ای پرداخت نمی‌کنید. در نظر داشته باشید در صورتی که از قبل از ارسال سفارش، از خرید آن محصول منصرف شوید، هدیه نیز به صورت اتوماتیک از سفارش شما حذف خواهد شد. همچنین در صورتی که بعد از دریافت سفارش، بخواهید آن محصول را مرجوع کنید، باید اصل محصول را به همراه هدیه آن مرجوع نمایید.',
            },
            {
                question: 'آیا امکان خرید حضوری یا تلفنی میسر می‌باشد؟',
                answer: 'خیر. تنها راه خرید از خانومی، ثبت سفارش از سایت خانومی و پرداخت از طریق روش‌های پرداخت ارائه شده در سایت است و در حال حاضر امکان هیچ‌گونه خرید حضوری، خرید تلفنی، پرداخت در محل یا پرداخت کارت‌به‌کارت وجود ندارد.',
            },
            {
                question: 'شهر محل سکونت من در لیست شهرها نمی‌باشد چگونه می‌توان سفارش را دریافت نمود؟',
                answer: 'شما می‌توانید با وارد کردن استان محل سکونت خود، نزدیکترین شهر به محل سکونت را انتخاب نمایید، در قسمت توضیحات آدرس کامل محل سکونت را درج کنید.',
            },
            {
                question: 'امکان دریافت سفارش در روز ثبت، امکان‌پذیر می‌باشد؟',
                answer: 'خیر، به دلیل تکمیل ظرفیت ارسال یا عدم امکان بسته‌بندی ، امکان ارسال در همان روز میسر نبوده و فقط طبق بازه نمایش داده شده در سایت که قابل انتخاب می‌باشد، ارسال انجام می‌گردد.',
            },
            {
                question: 'آیا درج کدپستی در زمان خرید الزامی می‌باشد؟',
                answer: 'درج کد پستی در زمان ثبت آدرس الزامی است. در صورتی که شهر شما در استان‌‌هایی به جز تهران و البرز قرار دارد، ارسال آن توسط پست انجام می‌گیرد؛ در این صورت لطفا از درستی کد پستی وارد شده اطمینان حاصل نمایید.',
            },
            {
                question: 'برند مورد نظرم را از چه قسمتی پیدا کنم؟',
                answer: 'پس از ورود به سایت خانومی، از طریق بخش جستجو در نوار بالای سایت یا از طریق نمایش لیست برندها در منوی سایت، برند مورد نظر خود را جستجو کنید.',
            },
            {
                question: 'محصول مورد نظرم موجود نیست، چه زمانی شارژ می‌شود؟',
                answer: 'زمان دقیق شارژ محصولات مشخص نیست و می‌توان با دنبال کردن سایت و استوری‌های پیج خانومی از زمان دقیق آن مطلع شد.',
            },
            {
                question: 'از چه طریق متوجه شوم کد تخفیف روی سفارشم اعمال شده است؟',
                answer: 'قبل از پرداخت، سبد خرید به شما نمایش داده می‌شود اگر از طریق سایت وارد شده باشید بالای صفحه سمت چپ مقدار کد تخفیف درج شده، اگر از طریق تلفن همراه اقدام به خرید نمایید پایین کالاها کادر کد تخفیف نمایش داده می‌شود و مبلغ نهایی سفارش شما قابل رویت می‌باشد.',
            },
        ],
    },
    {
        category: 'جعبه صورتی و شانس',
        id: 'chance',
        faqs: [
            {
                question: 'شانس در جعبه صورتی خانومی چیست؟',
                answer: 'شانس خانومی، فرصت خرید بی‌نظیری است که فروشگاه اینترنتی خانومی در اختیار خریداران و به خصوص مشتریان وفادار خود قرار می‌دهد. در شانس خانومی،‌ همان‌طور که از اسمش پیداست، شانس مشتریان سهم مهمی دارد. به این صورت که تعداد محدودی از یک کالا، برای مدت زمان محدودی، در فروش ویژه قرار می‌گیرد و پس از پایان زمان یا تعداد در نظر گرفته شده، تخفیف شانس حذف می‌شود و کالا به قیمت قبلی باز می‌گردد، باید در نظر داشت که، فقط یک عدد از هر محصول شانس برای هر مشتری در 24 ساعت (در صورت موجود بودن) امکان خرید وجود دارد.',
            },
            {
                question: 'تخفیف‌های شانس تا چه زمانی ادامه پیدا می‌کنند؟',
                answer: 'کالاهای شانس به مدت محدود در تخفیف بالا قرار می‌گیرند. این زمان ممکن است چند ساعت تا چند روز باشد، ‌مگر این که تعداد در نظر گرفته شده از کالاها با تخفیف ویژه به اتمام برسد. محصولات شانس هر روز در دو نوبت ۹ صبح و ۹ شب در سایت به روزرسانی می‌شوند. شما می‌توانید برای پیدا کردن محصول مورد نظر خود با بیشترین تخفیف، در این دو نوبت به سایت مراجعه و شانس خود را امتحان کنید.',
            },
            {
                question: 'چطور می‌توانم کالاهای شانس را پیدا کنم؟',
                answer: 'کافیست وارد سایت خانومی شوید و محصولات جعبه صورتی خانومی را مشاهده کنید. منتخبی از شانس‌های خانومی در صفحه اول نمایش داده می‌شوند و با کلیک بر روی گزینه «مشاهده همه» می‌توانید همه کالاهایی که در آن زمان در شانس هستند، مشاهده نمایید. دقت کنید کالاهای شانس به تعداد محدودی در سایت قرار می‌گیرند، پس بهتر است هر چه زودتر مراحل خرید خود را کامل کنید، تا با پیام «تمام شد» مواجه نشوید.',
            },
            {
                question: 'شرایط خرید کالاهای شانس چیست؟',
                answer: 'کالاهای شانس به مدت محدود در تخفیف بالا قرار می‌گیرند. جهت امکان استفاده از این تخفیفات برای همه مشتریان، در هر ۲۴ ساعت فقط یک بار می‌توانید کالایی با برچسب شانس را خریداری کنید.',
            },
        ],
    },
    {
        category: 'ویرایش سفارش',
        id: 'order-edit',
        faqs: [
            {
                question: 'آیا امکان حذف یا اضافه کردن کالا در سفارش ثبت شده وجود دارد؟',
                answer: 'امکان حذف یا اضافه کردن کالا در سفارش ثبت شده وجود ندارد. اما در صورتی که بسته شما در مرحله «ثبت سفارش» باشد، می‌توانید خرید خود را کنسل نمایید تا هزینه به اعتبار مجازی شما در سایت بازگردانده شود و سفارش جدیدی ثبت کنید. اگر برای ثبت سفارش گزینه پرداخت اقساطی با اسنپ‌پی را انتخاب کرده باشید، در صورتی کنسل شدن سفارش، هزینه پرداختی بین ۵ تا ۱۰ روز کاری به اعتبار شما در اسنپ‌پی باز‌ می‌گردد. توجه کنید در این صورت تخفیف‌ها و هدیه‌های موجود در فاکتور شما کنسل می‌شود و خریدی با شرایط جدید ثبت خواهید کرد. در صورتی که کالا به مرحله «در حال آماده‌سازی» رسیده باشد، امکان کنسل شدن سفارش وجود ندارد و لازم است تامل نمایید تا کالا توسط پیک یا پست به خانومی بازگشت داده شود و سپس هزینه بسته به حساب شما بازگردانده شود.',
            },
            {
                question: 'آیا امکان حذف یا اضافه کردن کالا به سفارش طلای ثبت شده وجود دارد؟',
                answer: 'پس از ثبت سفارش امکان هیچ ویرایشی وجود ندارد؛ تنها در صورتی که درخواست ویرایش سایز طلا (النگو، دستبند) را داشتید تنها تا 48 ساعت بعد از ثبت سفارش می‌توانید با پشتیبانی خانومی ارتباط بگیرید.',
            },
            {
                question: 'آیا امکان سفارش طلایی که دیده‌ام با تغییرات دلخواه یا به‌صورت سفارشی وجود دارد؟',
                answer: 'امکان تغییر در سایز، رنگ، نوع نگین، یا حتی ساخت اختصاصی فعلاً وجود ندارد.',
            },
            {
                question: 'چطور می‌توانم آدرس ارسال سفارش را پس از خرید تغییر دهم؟',
                answer: `در صورتی که سفارش شما در مرحله ثبت سفارش باشد، امکان اعمال هیچگونه تغییری وجود ندارد. اگر دریافت سفارش در آدرس ثبت شده برای شما مقدور نیست، شما می‌توانید با پشتیبانی امور مشتریان خانومی تماس بگیرید و سفارش خود را لغو کنید <span class="font-bold inline-block"><a href="tel:${primaryPhoneNumber.value}">${primaryPhoneNumber.delimited}</a> - <a href="tel:${secondaryPhoneNumber.value}">${secondaryPhoneNumber.delimited}</a></span> و یا لطفا تحمل فرمایید تا سفارش شما توسط پیک یا پست به خانومی بازگشت و هزینه سفارش به حساب شما بازگردانده شود.`,
            },
            {
                question: 'چطور می‌توانم تاریخ تحویل سفارش را پس از خرید تغییر دهم؟',
                answer: 'پس از ثبت سفارش، امکان اعمال هیچگونه تغییری در خصوص زمان تحویل وجود ندارد. در صورت عدم حضور شما در بازه انتخابی، امکان تحویل سفارش به شخص مورد تاییدتان وجود دارد. در غیر این صورت، سفارش شما مرجوع شده و حداکثر طی ۲ بار، هماهنگی لازم برای ارسال مجدد سفارش با شما انجام خواهد شد. در صورت عدم تمایل به ارسال مجدد، سفارش کنسل و هزینه به حساب شما بازگردانده خواهد شد.',
            },
            {
                question: 'کد تخفیف را فراموش کردم ثبت کنم، آیا امکان ثبت کد بعد از نهایی شدن خرید وجود دارد؟',
                answer: 'خیر، پس از نهایی شدن خرید، امکان ثبت کد تخفیف امکان‌پذیر نمی‌باشد. می‌توانید برای خرید بعدی، در صورت عدم اتمام تاریخ کد مورد نظر از آن استفاده نمایید.',
            },
            {
                question: 'آیا امکان جایگزین کردن محصول خریداری شده وجود دارد؟',
                answer: 'پس از نهایی کردن خرید، امکان جایگزین کردن کالا وجود ندارد، در صورت نیاز به کالای دیگر سفارش جدید ثبت نمایید.',
            },
            {
                question: 'آیا امکان لغو سفارش وجود دارد؟',
                answer: 'بله، در صورتی که وضعیت فاکتور در حالت ثبت سفارش باشد امکان لغو سفارش وجود دارد.',
            },
        ],
    },
    {
        category: 'پیگیری سفارش',
        id: 'order-tracking',
        faqs: [
            {
                question: 'چطور می‌توانم سفارشم را پیگیری کنم؟',
                answer: `از طریق بخش «خریدهای من» در حساب کاربری می‌توانید وضعیت سفارش خود را مشاهده فرمایید. همچنین می‌توانید با امور مشتریان تماس بگیرید و با ارائه شماره سفارش یا شماره همراه خود، از آخرین وضعیت سفارش‌تان مطلع شوید: <span class="font-bold inline-block"><a href="tel:${primaryPhoneNumber.value}">${primaryPhoneNumber.delimited}</a> - <a href="tel:${secondaryPhoneNumber.value}">${secondaryPhoneNumber.delimited}</a></span>`,
            },
            {
                question: 'در چه روزهایی امکان پیگیری سفارش وجود ندارد و خانومی تعطیل است؟',
                answer: `در سال ۱۴۰۵، روزهای جمعه، ۱ فروردین (آغاز نوروز)، ۱۳ فروردین (روز طبیعت)، ۱۴ خرداد (رحلت امام خمینی)، ۳ تیر (تاسوعا)، ۴ تیر (عاشورا)، ۱۳ مرداد (اربعین حسینی)، ۲۱ مرداد (رحلت حضرت رسول اکرم) و ۲۲ بهمن (سالگرد پیروزی انقلاب اسلامی)، شرکت خانومی تعطیل است و امکان پاسخگویی وجود ندارد. شما می‌توانید از طریق تلفن گویا مشکلات خود را ثبت و پس از روزهای تعطیل این موضوعات مورد پیگیری قرار خواهد گرفت.<br />
در سایر روزها، شنبه تا پنجشنبه از ساعت ۹ الی ۲۱ پاسخگوی سوالات شما هستیم.`,
            },
        ],
    },
    {
        category: 'ارسال و تحویل کالا',
        id: 'delivery',
        faqs: [
            {
                question: 'هزینه بسته‌بندی و ارسال به چه صورت می‌باشد؟',
                answer: 'هزینه‌ ارسال سفارش برای تهران، حومه تهران و البرز 119 هزار تومان است که توسط سفیران خانومی ارسال می‌گردد. برای سایر استان‌ها که ارسال به صورت پستی انجام می‌گردد، هزینه ارسال 113 هزار تومان است. {PACKAGING_COST_TEXT}',
            },
            {
                question: 'هزینه ارسال کالاهای با تگ «ارسال رایگان» چقدر است؟',
                answer: 'اگر محصولی در سبد خود دارید که مزیت «ارسال رایگان» دارد، هزینه‌ای بابت ارسال پرداخت نخواهید کرد و ارسال برای شما به طور کامل رایگان خواهد بود.',
            },
            {
                question: 'هزینه بسته‌بندی و ارسال طلا در خانومی چقدر است؟',
                answer: 'هزینه ارسال توسط فروشنده مشخص می‌شود و همان هزینه‌ای است که در فرآیند خرید در بخش "شیوه ارسال" در سایت مشاهده می‌کنید.',
            },
            {
                question: 'نحوه تحویل کالا در محل به چه صورت است؟',
                answer: 'سفیر خانومی و پست موظف هستند درب اصلی ساختمان منتهی به خیابان پس از برقراری ارتباط با مشتری، کالا را تحویل دهند. در نظر داشته باشید امکان حضور درب واحد برای سفیر مقدور نیست.',
            },
            {
                question: 'آیا امکان دریافت حضوری در سفارشات طلا وجود دارد؟',
                answer: 'امکان تحویل حضوری وجود ندارد و ارسال فقط به صورت پستی یا پیک انجام می‌گیرد.',
            },
            {
                question: 'چطور از زمانبندی ارسال سفارش مطلع شوم؟',
                answer: 'در هنگام ثبت‌ سفارش و بعد از مشخص کردن آدرس و انتخاب روش ارسال، می‌توانید زمانبندی‌های موجود برای ارسال را مشاهده کنید. پس از ثبت سفارش نیز می‌توانید زمانبندی دریافت کالا را از طریق پیامک ارسالی یا از طریق بخش «سفارش‌های من» در حساب کاربری خود مشاهده کنید.',
            },
            {
                question: 'کد رهگیری مرسوله پستی سفارش خود را در کدام قسمت از سایت می‌توان مشاهده کرد؟',
                answer: 'با انتخاب روش پستی و تحویل کالا به پست، کد رهگیری پستی از طریق پیامک برای شما ارسال می‌گردد، همچنین می‌توانید در سایت خانومی وارد پروفایل خود شوید، بر روی این لینک کلیک نمایید سپس در قسمت ارسال شده بر روی گزینه جزئیات سفارش مورد نظر کلیک کرده و کد رهگیری را مشاهده نمایید.',
            },
            {
                question: 'نحوه ارسال به چه صورت می‌باشد؟',
                answer: 'در شهر تهران و البرز توسط سفیران خانومی و سایر استان‌ها به صورت پستی تحویل می‌گردد.',
            },
            {
                question: 'سفارش‌های طلا در خانومی از چه طریقی ارسال می‌شوند؟',
                answer: 'بسته‌بندی و ارسال کالا توسط فروشنده و از طریق پیک فروشگاه یا شرکت‌های پستی انجام می‌شود.',
            },
            {
                question: 'آیا امکان تغییر زمان تحویل وجود دارد؟',
                answer: 'بسته شما در بازه انتخابی هنگام ثبت سفارش تحویل می‌گردد و امکان تغییر آن وجود ندارد.',
            },
            {
                question: 'کد تحویل چیست؟',
                answer: 'خانومی برای اطمینان از دریافت بسته توسط مشتری کدی برای گیرنده بسته پیامک می‌کند تا در زمان مراجعه‌ سفیر آن‌ را به مأمور ارسال تحویل و بسته خود را دریافت کند. در صورت عدم ارائه‌ی کد تحویل به سفیر، بسته به انبار خانومی برگشت داده خواهد شد.',
            },
            {
                question: 'کد تحویل را از کجا می‌توانم دریافت کنم؟',
                answer: 'کد تحویل از طریق پیامک به شماره موبایل گیرنده بسته ارسال می‌شود. همچنین می‌توانید با ورود به حساب کاربری خود در سایت خانومی و مراجعه به بخش سفارش‌های من، کد تحویل خود را مشاهده کنید.',
            },
            {
                question: 'چه زمانی کد تحویل ارسال می‌شود؟',
                answer: 'در روز تعیین‌شده برای ارسال سفارش، کد تحویل به‌صورت خودکار ایجاد شده و برای مشتری ارسال می‌شود. در صورتی که گیرنده بسته فرد دیگری باشد، این پیامک برای ایشان نیز ارسال می‌گردد.',
            },
        ],
    },
    {
        category: 'بازگشت کالا',
        id: 'return',
        faqs: [
            {
                question: 'شرایط ضمانت بازگشت رایگان کالا چیست؟',
                answer: 'به دلیل مقررات بهداشت، امکان انصراف از خرید و بازگشت کالا به دلایل سلیقه‌ای وجود ندارد. کالا تنها در صورتی به دلیل عدم تطابق با سلیقه مشتری و انصراف از خرید پس گرفته می‌شود که دارای شرایط اولیه باشد. توجه کنید در صورتی که با انصراف از خرید تک محصول و بازگرداندن کالا، شرط اولیه ارسال رایگان نقض شود، هزینه ارسال از مبلغ محصول کسر شده و مابقی برای شما واریز می‌شود. انصراف از کل سفارش شامل هزینه ارسال نمی‌گردد.',
            },
            {
                question: 'شرایط بازگشت کالای غیر اصل چیست؟',
                answer: 'خانومی با افتخار اصالت کالاها را تضمین می‌کند و با اطمینان کامل می‌توانید خرید خود را انجام دهید. در صورتی که از اصالت کالایی که دریافت کرده‌اید اطمینان ندارید، امکان ثبت درخواست شما برای مرجوعی با ارائه مستندات در مورد اصل نبودن کالا، تا ۷ روز پس از تاریخ تحویل سفارش وجود دارد. در صورت وجود مشکل لطفاً با امور مشتریان خانومی تماس بگیرید و موضوع را اطلاع دهید.',
            },
            {
                question: 'شرایط بازگشت کالا به صورت سلیقه‌ای چیست؟',
                answer: 'تمامی کالاهای فروشگاه خانومی شرایط بازگشت کالا در صورتی که پلمپ و در شرایط اولیه باشند را تا 7 روز دارا می‌باشد.',
            },
            {
                question: 'شرایط بازگشت کالای طلا به صورت سلیقه‌ای چیست ؟',
                answer: 'با توجه به ماهیت خاص محصولات طلا، امکان انصراف از خرید یا مرجوعی به دلایل سلیقه‌ای در خانومی وجود ندارد.',
            },
            {
                question: 'آیا امکان مرجوعی طلا در خانومی وجود دارد؟',
                answer: 'در صورت معیوب بودن کالا، به شرط عدم استفاده از محصول و با تایید کارشناسان، تا ۳ روز پس از دریافت، امکان مرجوعی وجود دارد.',
            },
            {
                question: 'چگونه درخواست مرجوعی را ثبت کنم؟',
                answer: `جهت بازگرداندن کالا و استفاده از خدمات پس از فروش خانومی، لطفا در سایت، از طریق آیکون صورتی رنگ پایین صفحات وارد چت آنلاین شده و با کارشناسان خدمات پس از فروش ما در ارتباط باشید. کارشناسان امور مشتریان خانومی در سریع‌ترین زمان ممکن، پاسخگوی شما هستند. همچنین جهت پیگیری می‌توانید با امور مشتریان خانومی تماس بگیرید: <span class="font-bold inline-block"><a href="tel:${primaryPhoneNumber.value}">${primaryPhoneNumber.delimited}</a> - <a href="tel:${secondaryPhoneNumber.value}">${secondaryPhoneNumber.delimited}</a></span>`,
            },
            {
                question: 'کالا را به چه روشی برای خانومی عودت کنم؟',
                answer: 'پیش از هر چیز، برای مشخص کردن روش بازگرداندن کالا، با امور مشتریان خانومی هماهنگ نمایید. بازگشت کالا در استان‌های تهران و البرز در زمان هماهنگ شده توسط پیک خانومی انجام می‌شود. هزینه بازگشت کالا در صورت تایید شرایط مرجوعی (به استثنا انصراف از خرید) از شهرستان به عهده خانومی است، اما لازم است قبض پست به همراه کالا ارسال شده و یا در اولین فرصت تصویر آن از طریق چت آنلاین، برای بخش امور مشتریان خانومی فرستاده شود. توجه کنید در صورتی که کالا بدون هماهنگی یا به روشی غیر از استفاده از سیستم حمل و نقل مورد تایید خانومی (تهران ارسال با اکسپرس، شهرستان ارسال با پست) بازگردانده شود، هزینه بازگرداندن کالا به عهده مشتری خواهد بود.',
            },
            {
                question: 'تا چند روز مهلت دارم محصول خریداری شده ی خود را مرجوع کنم؟',
                answer: 'مشتریان تا 7 روز از زمان تحویل کالا مهلت دارند درخواست مرجوعی و ارائه مستندات خود را از طریق چت آنلاین اعلام کنند.',
            },
            {
                question: 'اگر طلایی که دریافت کرده‌ام ایراد یا مشکلی داشته باشد، چه اقدامی باید انجام دهم؟',
                answer: `در صورت مشاهده‌ هرگونه ایراد یا مغایرت در طلای خریداری‌شده، لطفاً حداکثر تا سه روز پس از دریافت بسته وارد سایت خانومی شده و از طریق چت آنلاین موجود در سایت، مورد را به پشتیبانی اعلام کنید.<br />
پس از بررسی کارشناسان، در صورت تأیید ایراد، مراحل پیگیری و رفع مشکل برای شما انجام خواهد شد.`,
            },
            {
                question: 'آیا مسئولیت مربوط به کالاهای دارویی-مراقبتی و سنجش سلامت به عهده ی شرکت خانومی است؟',
                answer: 'دستورالعمل استفاده از اینگونه محصولات، بهتر است با مشورت پزشک همراه باشد، لذا عوارض ناشی از مصرف این نوع کالاها به عهده مشتری می‌باشد.',
            },
            {
                question: 'کالاهای برقی که دارای گارانتی شرکتی می‌باشند تحت چه شرایطی امکان مرجوعی دارند؟',
                answer: 'در صورتی که کالای خریداری شده پلمپ (در شرایط اولیه)، مغایرت با اطلاعات سایت داشته باشد تا 7 روز امکان اعلام مرجوعی آن وجود دارد، در صورتی که این کالاها دارای ایراد فنی باشند، به گارانتی محصول باید مراجعه گردد.',
            },
            {
                question: 'کالاهای برقی که بدون گارانتی شرکتی می‌باشند تحت چه شرایطی امکان مرجوعی دارند؟',
                answer: 'در صورتی که کالای خریداری شده پلمپ (در شرایط اولیه)، ایراد فنی یا مغایرت با اطلاعات سایت داشته باشد تا 7 روز امکان اعلام مرجوعی آن وجود دارد.',
            },
            {
                question: 'کالایی که خریداری شده، در صورت داشتن کسری تا چند روز مهلت اعلام آن وجود دارد؟',
                answer: 'مشتریان تا 7 روز از زمان تحویل کالا مهلت دارند کسری کالای خود را از طریق چت آنلاین اعلام کنند.',
            },
            {
                question: 'روش صحیح بسته‌بندی کالای مرجوعی به چه صورت است؟',
                answer: 'کالا می‌بایست در جعبه اصلی خود به همراه لیبل نارنجی یا سفید به خانومی بازگردانده شود. لازم است بسته اصلی محصولات تا پایان 7 روز مهلت استفاده، نگهداری شود و از دور ریختن آن جداً خودداری شود. در صورتی که کالا بسته‌بندی کارتنی ندارد، در بسته‌بندی نایلونی که با چسب محفوظ شده است تحویل سفیر خانومی یا اداره پست گردد.',
            },
            {
                question: 'اگر کالایی که خریدم در حمل و نقل آسیب ببیند چگونه از خدمات پس از فروش استفاده کنم؟',
                answer: 'آسیب‌دیدگی باید حداکثر طی 7 روز پس از دریافت کالا، از طریق چت آنلاین یا تماس با پشتیبانی خانومی اطلاع‌رسانی گردد.',
            },
            {
                question: 'چطور می‌توانم با گارانتی مدنظر خود تماس بگیرم؟',
                answer: 'شماره تماس گارانتی بر روی کارت گارانتی محصول درج شده است.',
            },
        ],
    },
    {
        category: 'قوانین انتشار دیدگاه',
        id: 'comments-rules',
        faqs: [
            {
                question: 'در مورد چه مواردی می‌توانم دیدگاه خود را ثبت کنم؟',
                answer: 'در مورد تمامی موارد مربوط به کیفیت محصول و تجربه استفاده از آن می‌توانید امتیاز و دیدگاه خود را ثبت کنید. دیدگاه ارسالی باید منطبق بر شئونات جامعه و با بیان رسمی و به دور از توهین باشد. دیدگاه شما پس از بررسی و تایید، در صفحه محصول مرتبط، نمایش داده خواهد شد. در نظر داشته باشید موارد مرتبط با موجودی، قیمت محصولات و خدمات پس از فروش را از طریق امور مشتریان فروشگاه اینترنتی خانومی پیگیری فرمایید.',
            },
            {
                question: 'در چه حالت عکس ارسالی همراه دیدگاه تایید می‌شود؟',
                answer: 'عکس ارسالی باید مطابق با عرف و شئونات جامعه باشد. داشتن پوشش مناسب و نداشتن تتو از شروط اساسی تایید محتوای تصویری است. همچنین عکس ارسالی برای تایید و نمایش در سایت باید با کیفیت باشد. پس خواهشمندیم از تمیز بودن لنز دوربین و کیفیت آن اطمینان حاصل فرمایید.',
            },
        ],
    },
    {
        category: 'پرداخت و استرداد',
        id: 'payment',
        faqs: [
            {
                question: 'چطور می‌توانم هزینه سفارشم را پرداخت کنم؟',
                answer: 'برای خرید از خانومی، پرداخت تنها به صورت اینترنتی از طریق سایت خانومی امکان‌پذیر است . پرداخت در محل یا به صورت نقدی امکان‌پذیر نمی‌باشد.',
            },
            {
                question: 'نحوه پرداخت اقساطی به چه صورت می‌باشد؟',
                answer: `۱. در مرحلهٔ پرداخت، گزینه پرداخت اقساطی اسنپ‌پی را انتخاب کنید. <br />
                ۲. شماره موبایلی که با آن در اسنپ‌پی ثبت‌نام کرده‌اید را وارد کنید. <br />
                ۳. کد تأیید ارسال شده را وارد کنید. <br />
                ۴. با پرداخت قسط اول خریدتان نهایی می‌شود. (همچنین بعد از پرداخت قسط اول کالا در بازه انتخاب شده خدمت شما ارسال می‌گردد) سقف خرید اقساط شما در اسنپ‌پی مشخص می‌شود.`,
            },
            {
                question: 'آیا امکان پرداخت اقساطی از سایر سرویس‌ها میسر می‌باشد؟',
                answer: 'خیر فقط به صورت خرید اقساطی از اسنپ‌پی میسر می‌باشد.',
            },
            {
                question: 'خرید اقساطی انجام نمی‌شود چه علتی دارد؟',
                answer: `ابتدا نیاز است نرم افزار اسنپ را از داخل اینترنت، سایت اسنپ (<a href="https://snapp.ir/" class="text-alert-info-dark" rel="noreferrer noopener">snapp.ir</a>) و یا نرم افزاری مانند بازار دانلود کنید. <br />
                توجه داشته باشید در صورتی که شما واجد شرایط خرید اعتباری و اقساطی نباشید در این قسمت به شما خطا نمایش داده می‌شود. سپس داخل نرم افزار اسنپ گزینه سرویس اعتباری را انتخاب کرده و با وارد کردن کدملی و شماره تلفن همراه ثبت‌نام خود را انجام دهید و با همان شماره وارد سایت خانومی شوید.`,
            },
            {
                question: 'اقساط خود را در اسنپ‌پی به چه صورت پرداخت نمایم؟',
                answer: 'وارد برنامه اسنپ شده، از قسمت سرویس اعتباری وارد حساب کاربری خود شوید و از این قسمت می‌توانید اقساط خود را مشاهده و پرداخت کنید.',
            },
            {
                question: 'مبلغ سفارش از حسابم کسر شده اما سفارشم نهایی نشده است.',
                answer: 'اگر طی ۷۲ ساعت آینده مبلغ به حساب شما بازگشت داده نشد، ابتدا با بانک مبدا بررسی کرده بعد از حصول اطمینان از عدم واریزی با پشتیبانی خانومی در ارتباط باشید.',
            },
            {
                question: 'مبلغ سفارش لغو شده چطور به حساب عودت داده می‌شود؟',
                answer: `حالت اول: در صورتی که سفارش از طریق درگاه بانکی پرداخت شده باشد ، مبلغ به اعتبار مجازی مشتری افزوده می‌شود. <br />
                حالت دوم: در صورتی که سفارش از طریق اسنپ‌پی پرداخت شده باشد ، مبلغ طی 3 الی 5 روز کاری به اعتبار اسنپ‌پی مشتری بازگشت داده میشود.`,
            },
            {
                question: 'از طریق اسنپ‌پی خرید انجام دادم ، در صورت حذف محصول ، نحوه عودت مبلغ به چه صورت می‌باشد؟',
                answer: `در صورتی که مبلغ کالا کمتر از اقساط محاسبه شده باشد ، مبلغ کالا از باقی اقساط کسر می‌شود. <br />
                در صورتی که مبلغ کالا بیشتر از اقساط محاسبه شده باشد ، پرداختی به صورت مستقیم از طریق اسنپ‌پی صورت می‌گیرد.`,
            },
            {
                question: 'چطور هنگام پرداخت، رمز پویا دریافت کنم؟',
                answer: 'لازمه دریافت رمز پویا در درگاه پرداخت این است که قابلیت دریافت رمز پویا برای کارت شما فعال باشد. در صورت فعال بودن این قابلیت، برای دریافت رمز پویا (رمز یکبار مصرف)، باید ابتدا در صفحه درگاه پرداخت بانک، شماره کارت خود، کد سه یا چهار رقمی روی کارت (CVV2)، تاریخ انقضای کارت و کد امنیتی نمایش داده شده را وارد و روی گزینه «دریافت رمز پویا» یا «رمز پویا» کلیک کنید. پس از دریافت پیامک رمز پویا، به صفحه درگاه پرداخت بانک برگردید و رمز پویا را وارد کرده و پرداخت را انجام دهید. اگر پیامک رمز پویا را دریافت نکردید، پس از ۲ دقیقه می‌توانید مجدداً درخواست ارسال رمز پویا دهید.',
            },
            {
                question: 'تسویه حساب کالای بازگردانده شده چگونه انجام می‌شود؟',
                answer: `پس از دریافت کالا توسط بخش خدمات پس از فروش، در صورت تایید شرایط مرجوعی، هزینه کالا و هزینه پست سفارشی برای مرجوعی کالا در صورت ارسال از شهرستان به اعتبار مجازی مشتری در سایت خانومی واریز می‌شود. <br />
                در صورت بازگرداندن کالا با عنوان انصراف از خرید هزینه پست به عهده مشتری می‌باشد و فقط هزینه کالا عودت داده می‌شود.`,
            },
            {
                question: 'چگونه درخواست تسویه اعتبار مجازی خود را ثبت کنم؟',
                answer: 'شما می‌توانید به بخش «کیف پول» در حساب کاربری خود مراجعه و گزینه برداشت اعتبار را انتخاب کنید. نام و شماره شبای خود را در این بخش ثبت کنید. در نظر داشته باشید شماره شبا باید به نام خریدار و صاحب شبا باشد. پس از ثبت شماره شبا، مبلغ اعتبارتان طی ۷۲ ساعت کاری به حساب ثبت شده واریز و از طریق پیامک اطلاع‌رسانی خواهد شد.',
            },
        ],
    },
    {
        category: 'قیمت گذاری خرید و دریافت فاکتور طلا',
        id: 'gold-pricing-and-invoice',
        faqs: [
            {
                question: 'قیمت طلا چطور محاسبه می شود؟',
                answer: `قیمت طلای به‌ کار رفته = قیمت روز یک گرم طلا × وزن طلای به کار رفته (گرم)<br />
اجرت ساخت = درصد اعلامی اجرت فروشنده × قیمت طلای به‌ کار رفته<br />
سود فروشنده = درصد اعلامی سود فروشنده × (قیمت طلای به‌ کار رفته + اجرت ساخت)<br />
مالیات = ۱۰٪ × (اجرت ساخت + سود فروشنده + قیمت اجزای غیرطلا)<br />
قیمت نهایی محصول = قیمت طلای به‌ کار رفته + اجرت ساخت + سود فروشنده + قیمت اجزای غیرطلا + مالیات<br />`,
            },
            {
                question: 'بعد از خرید طلا از خانومی فاکتور چطور دریافت می شود؟ ',
                answer: 'اصل فاکتور توسط فروشنده در بسته‌بندی قرار داده خواهد شد و به دست مشتری می‌رسد.',
            },
        ],
    },
]
